module.exports = __webpack_public_path__ + "img/animals_pig.a2f07f97.png";